import { render } from "./docfocus.vue?vue&type=template&id=35d35a97"
import script from "./docfocus.vue?vue&type=script&lang=js"
export * from "./docfocus.vue?vue&type=script&lang=js"

import "./docfocus.vue?vue&type=style&index=0&id=35d35a97&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__